const getInitials = (string: string) => {
    const names = string?.split(' ');
    if ((names?.length ?? 0) == 0) return "";
    const validnames = names.filter(x => x != "")
    if ((validnames?.length ?? 0) == 0) return "";
    let initials = validnames[0].substring(0, 1).toUpperCase();

    if (validnames.length > 1) {
        initials += validnames[validnames.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
};

export default getInitials;